import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import Input from '@material-ui/core/Input';

import { LocalHospital as LocalHospitalIcon } from '@material-ui/icons';
import Paper from '~/components/Paper';
import InputControl from '~/components/Input/InputControl';
import Form from '~/containers/Form';
import GridContainer from '~/components/GridContainer';
import GridItem from '~/components/GridItem';
import useStyles from './styles';
import AppointmentTagsRecord from '~/records/AppointmentTagsRecord';

const attrName = (attr) => AppointmentTagsRecord.hummanAttributeName(attr);

function AppointmentCategoriesItem({
  record,
  handleChange,
  onSubmit,
  loading,
  // setRecord,
}) {
  const classesRoot = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <Form onSubmit={onSubmit}>
        <Paper
          Icon={LocalHospitalIcon}
          iconColor="blue"
          title={t('appointmentTags.defSingular')}
          loading={loading}
        >
          <div className={clsx(classesRoot.root)}>
            <GridContainer>
              <GridItem xs={12} md={12}>
                <InputControl
                  name={'name'}
                  value={record.get('name')}
                  label={attrName('name')}
                  required={true}
                  inputComponent={Input}
                  onChange={handleChange}
                />
              </GridItem>
            </GridContainer>
          </div>
        </Paper>
      </Form>
    </>
  );
}

AppointmentCategoriesItem.propTypes = {
  record: PropTypes.instanceOf(AppointmentTagsRecord).isRequired,
  handleChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  setRecord: PropTypes.func.isRequired,
};

AppointmentCategoriesItem.defaultProps = {
  loading: false,
};

export default React.memo(withRouter(AppointmentCategoriesItem));
